export const MODULE = {
  authConsole: 'AUTH',
  saucerLog: 'saucer-logs',
  caremoniConsole: 'CAREMONI-CONSOLE'
};
